import _extends from "@babel/runtime/helpers/extends";
import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import React, { forwardRef } from "react";
import { ursaTypeRampDefinitions } from "../../typography/constants/ursaConstants";
import { ChipLabelStyled } from "../styled/ChipLabelStyled";
var chipLabelTypeRampTheme = {
  medium: "Inter--12px--600w",
  small: "Inter--12px--600w",
  xsmall: "Inter--12px--600w"
};
export var ChipLabel = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    omitTooltip = _ref.omitTooltip,
    size = _ref.size;
  var ursaVariant = ursaTypeRampDefinitions[chipLabelTypeRampTheme[size]];
  var themeMode = useCombinedThemeMode();
  return /*#__PURE__*/React.createElement(ChipLabelStyled
  // Lodestar and Ursa Chips both use the same font styles.
  , _extends({
    system: "ursa",
    variant: chipLabelTypeRampTheme[size],
    omitTooltip: omitTooltip,
    lineClamp: 1,
    ref: ref,
    themeMode: themeMode,
    chipSize: size
  }, ursaVariant), children);
});
ChipLabel.displayName = "ChipLabel";
//# sourceMappingURL=ChipLabel.js.map